<!--
* UIID: UI-DLB-MAP-170
* UI Name: Mapping Definition List
* Modify Date: 2020/08/21
-->
<template>
  <dialog-drag
    :id="id"
    :ref="'dialog-' + id"
    :options="options"
    @close="removeDialog"
    @drag-end="dialogDragEnd"
    @drag-start="selectDialog"
    @move="dialogDragEnd"
  >
    <!-- [S]  Popup title-->
    <template v-slot:title>
      <!-- [S]  Popup title-->
      <v-card-title class="headline white--text" primary-title>
        {{ $t('lbl.mapManager.mappingDefinitionList') }}
        <v-spacer /><v-icon small class="mr-2" @click="removeDialog" color="white"
          >fas fa-times</v-icon
        >
      </v-card-title>
      <!-- [E]  Popup title-->
    </template>
    <v-card class="analyzed-dialog matched-map-list-dialog">
      <!-- [S]  Popup body-->
      <v-card-text class="content-section pa-0">
        <v-row class="content-covering">
          <v-col cols="12" class="pa-0">
            <v-row class="ma-0 pb-search">
              <v-col cols="4" class="pa-0"></v-col>
              <v-col cols="4" class="pa-0"></v-col>
              <v-col cols="4" class="pa-0">
                <v-text-field
                  v-model="search"
                  placeholder="Search"
                  class="search-matched-map-list-button custom-form-component search-button search-field-color"
                  outlined
                  dense
                  solo
                  hide-details
                  append-icon="fas fa-search"
                  height="30"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row class="data-table-flat-file-list ma-0">
              <!-- // 203737 05/19/2021 Issue 53 No display spinner when enter Dashboard, Transaction Log and Workflow via left menu -->
              <system-progress
                :sysloading="isLoading"
                :sysloadingTitle="sysloadingTitle"
              ></system-progress>
              <v-col cols="12" class="pa-0">
                <v-data-table
                  :search="search"
                  :fixed-header="true"
                  :hide-default-footer="true"
                  :headers="map_table_header"
                  :items="mapDefinitionList"
                  class="analyzed-layout-table matched-map-list flatfile-layout-list-data-table"
                  disable-pagination
                  disable-sort
                  height="186"
                >
                  <template v-slot:body="{ items }">
                    <tbody>
                      <tr v-for="item in items" :key="item.id">
                        <td class="text-center align-radio">
                          <input
                            type="radio"
                            :value="item.MPD_FILE_NAME"
                            name="matched-map"
                            @click="selectMapDefinitionFile(item)"
                          />
                        </td>
                        <td class="flat-file-layout-col text-left">
                          <a @click="downloadMapDefinitionFile(item)">{{ item.MPD_FILE_NAME }}</a>
                        </td>
                        <td class="sender-col text-center">{{ item.MPD_VERSION }}</td>
                        <td class="text-center">{{ item.MPD_UPD_DT }}</td>
                      </tr>
                    </tbody>
                  </template>
                  <template v-slot:no-data>
                    <v-btn color="primary" @click="initialize">{{ $t('btn.common.reset') }}</v-btn>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-card-text>
      <!-- [E]  Popup body-->

      <!-- [S]  Popup buttons-->
      <v-card-text class="footer-display">
        <v-row class="ma-0">
          <v-col cols="12" class="pa-0">
            <v-btn class="dialog-btn btn-delete ma-0 float-right" tile dark @click="removeDialog">
              <v-icon small color="white" class="mr-1">fa fa-times</v-icon>
              {{ $t('btn.common.close') }}
            </v-btn>
          </v-col>
        </v-row>
      </v-card-text>
      <!-- [E]  Popup buttons-->
    </v-card>
  </dialog-drag>
</template>

<script>
/* globals Store */
import { mapState } from 'vuex';

import DialogDrag from '@/vue-dlb/components/vue-dialog-drag.vue';
// 203737 05/19/2021 Issue 53 No display spinner when enter Dashboard, Transaction Log and Workflow via left menu
import SystemProgress from '@/vue-dlb/components/SystemProgress.vue';
/* 2020/11/06 203737 Remove unused source
import controlData from '../Data/asset-creation/data_control.json'*/

export default {
  components: {
    DialogDrag,
    SystemProgress,
  },
  computed: {
    ...mapState('map', {
      mapDefinitionList: 'mapDefinitionList',
    }),
    // 203737 05/19/2021 Issue 53 No display spinner when enter Dashboard, Transaction Log and Workflow via left menu
    ...mapState('common', {
      sysloadingTitle: 'sysloadingTitle',
    }),
  },
  /* 2020/10/29 203737 Change prop definitions
    props: ['id', 'title', 'options', 'eventCb', 'selectMapFile', 'closeDialog', 'dragStart', 'dragEnd', 'fileSelected'],*/
  props: {
    id: String,
    options: Object,
    selectMapFile: Function,
    closeDialog: Function,
    dragStart: Function,
    dragEnd: Function,
  },
  name: 'mappingDefinition-list',
  data: () => ({
    search: '',
    map_table_header: [
      { value: '', text: 'Select', width: 60 },
      { value: 'MPD_FILE_NAME', text: 'Mapping Definition Name', width: 200 },
      { value: 'MPD_VERSION', text: 'Version', width: 70 },
      { value: 'MPD_UPD_DT', text: 'Update Date', width: 145 },
    ],
    masterSearchItems: {
      header: ['ADMIN_YN', 'CUST_ID'],
      data: [
        {
          ADMIN_YN: '',
          CUST_ID: '',
        },
      ],
    },
    mapDefinitionFileDownloadItems: {
      header: ['FILE_ID', 'ATF_FILE_NAME'],
      data: [
        {
          SAVE_NAME: '',
          FILE_ID: '',
          ATF_FILE_NAME: '',
        },
      ],
    },
    isLoading: true,
  }),
  created() {
    this.queryReferenceFilesList();
  },
  methods: {
    queryReferenceFilesList() {
      // 203737 05/19/2021 Issue 53 No display spinner when enter Dashboard, Transaction Log and Workflow via left menu
      this.isLoading = true;
      console.log('--------- queryReferenceFilesList ----------');
      this.masterSearchItems.data[0].ADMIN_YN = $cookies.get('used-repo');
      this.masterSearchItems.data[0].CUST_ID = $cookies.get('comp-id');
      Store.dispatch('map/queryMappingDefinitionList', this.masterSearchItems)
        .then(() => {
          console.log('--------- Finished to process ----------');
          console.log(this.mapDefinitionList);
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
    downloadMapDefinitionFile(item) {
      this.mapDefinitionFileDownloadItems.data[0].SAVE_NAME = item.MPD_FILE_NAME;
      this.mapDefinitionFileDownloadItems.data[0].FILE_ID = item.FILE_ID;
      this.mapDefinitionFileDownloadItems.data[0].ATF_FILE_NAME = item.MPD_FILE_NAME;
      Store.dispatch('common/DownloadFileFromServer', this.mapDefinitionFileDownloadItems).then(
        () => {
          console.log('--------- Finished to process ----------');
        }
      );
    },
    removeDialog(dialog) {
      dialog.id = this.id;
      this.closeDialog(dialog);
    },
    selectMapDefinitionFile(item) {
      if (!this.options.item.readOnly) {
        this.removeDialog({});
        this.selectMapFile(item);
      }
    },
    selectDialog(obj) {
      this.dragStart(obj);
    },
    dialogDragEnd(obj) {
      this.dragEnd(obj);
    },
  },
};
</script>
<style>
/* .theme--dark .matched-map-list .v-data-table__wrapper{
  background: #292C35;
}
.theme--light .matched-map-list .v-data-table__wrapper{
  background: #FFFFFF;
} */
</style>
